<template>
  <div class="home">
    <h2>Tutoriel d'administration d'EXPLORE</h2>
    <p>Consulter la <a href="https://docs.google.com/document/d/15gYOfXdhp9PepZj8AV89lpoTHqlqOE3UWQ4QxHl3WXQ/edit?usp=sharing">version éditable du tutoriel (Google Doc)</a> - <a href="https://docs.google.com/document/d/15gYOfXdhp9PepZj8AV89lpoTHqlqOE3UWQ4QxHl3WXQ/export?format=pdf">le télécharger (pdf)</a></p>
    <Status :message="currentLinks"></Status>
    <h2>Captures d'écran</h2>
    <p><a href="https://photos.app.goo.gl/V1q2fnx55R98srUJA">🖼 Consulter les derniers screenshots du prototype</a></p>
  </div>
</template>

<script>
// @ is an alias to /src
import Status from '@/components/Status'

export default {
  name: 'home',
  components: {
    Status
  },
  data: function () {
    return {
      currentLinks: `
### Hall
Part-Dieu : [https://explore.placed.eu/#/hall](https://explore.placed.eu/#/hall)

2ème : [https://explore.placed.eu/#/hall/3](https://explore.placed.eu/#/hall/3)

### Part Dieu
Société - [https://explore.placed.eu/#/5108](https://explore.placed.eu/#/5108) - La revanche des villages

Civilisation - [https://explore.placed.eu/#/5134](https://explore.placed.eu/#/5134) - Le moi-cyborg

### 2e
Société - [https://explore.placed.eu/#/5139](https://explore.placed.eu/#/5139) - Fabricolivre : voyage dans l'espace

Jeunesse - [https://explore.placed.eu/#/5139](https://explore.placed.eu/#/5139) - Fabricolivre : voyage dans l'espace`
    }
  }
}
</script>
